
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthProvider";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import Index from "./pages/Index";
import AdminPage from "./pages/AdminPage";
import UsersPage from "./pages/UsersPage";
import ProfilePage from "./pages/ProfilePage";
import ResultsPage from "./pages/ResultsPage";
import CareerChat from "./pages/CareerChat";
import SentryTest from "./pages/SentryTest";
import AssistantTest from "./pages/AssistantTest";
import PersonTest from "./pages/PersonTest";
import NotFound from "./pages/NotFound";
import ChatPopup from "./components/chat/ChatPopup";

// Wrap main components with Sentry profiler
const SentryIndex = Sentry.withProfiler(Index);
const SentryAdminPage = Sentry.withProfiler(AdminPage);
const SentryCareerChat = Sentry.withProfiler(CareerChat);
const SentrySentryTest = Sentry.withProfiler(SentryTest);
const SentryAssistantTest = Sentry.withProfiler(AssistantTest);
const SentryPersonTest = Sentry.withProfiler(PersonTest);

// Analytics tracker component
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view
    if (window.gtag) {
      window.gtag('config', 'G-1MXNG73LC6', {
        page_path: location.pathname,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [location]);
  
  return null;
};

const App = () => (
  <AuthProvider>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<SentryIndex />} />
          <Route path="/admin" element={<SentryAdminPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/chat" element={<SentryCareerChat />} />
          <Route path="/sentrytest" element={<SentrySentryTest />} />
          <Route path="/assistant-test" element={<SentryAssistantTest />} />
          <Route path="/person-test" element={<SentryPersonTest />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ChatPopup />
      </BrowserRouter>
    </TooltipProvider>
  </AuthProvider>
);

export default App;
